<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-row style="display: flex;align-items: center;">
              <div class="searchStyle" style="font-size: 16px;">
                活动管理
              </div>
            </el-row>
            <el-row>
              <el-button type="primary" round @click="editCompetition()">添加</el-button>
            </el-row>
          </div>
        </div>

        <div style="padding: 10px;">
          <el-table ref="multipleTable" :data="filterData" :header-cell-style="{background:'#eef1f6',color:'#606266'}"
            style="width: 100%" @sort-change="changeSort" highlight-current-row>
            <el-table-column type="index" label="序号" width="100" :index="indexMethod">
            </el-table-column>
            <el-table-column prop="title" label="活动名称">
            </el-table-column>

            <el-table-column prop="preface_image_url" label="首页图片(16:9)" width="200">
              <template slot-scope="scope">
                <div @click="editImage(scope.row.id)">
                  <!-- {{scope.row.image_name}} -->
                  <img :src="getImageUrl(scope.row.preface_image_url)" style="width: 160px;height:90px;" />
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="category" label="活动类别">
            </el-table-column>

            <el-table-column prop="start_time" label="开始时间">
            </el-table-column>

            <el-table-column prop="end_time" label="结束时间">
            </el-table-column>


            <el-table-column label="操作" align="center" width="300">
              <template slot-scope="scope">
                <el-button @click.native.prevent="delCompetition(scope.$index, filterData)" type="text" size="small">
                  删除
                </el-button>
                <el-button @click.native.prevent="manageCompetition(scope.$index, filterData)" type="text" size="small">
                  管理
                </el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>

      </el-col>
    </el-row>

    <el-dialog title="添加新科目" :visible.sync="editDialogVisible" width="40%">
      <el-form :model="form">
        <el-form-item label="科目名称" :label-width="formLabelWidth">
          <el-input v-model="form.course_name" autocomplete="off" placeholder="输入科目名称"></el-input>
        </el-form-item>
        <el-form-item label="数据类型" :label-width="formLabelWidth">
          <el-radio-group v-model="form.course_type" size="mini">
            <el-radio label="1" style="margin-bottom: 20px;margin-top: 15px;">录入的是数字类成绩,如分数</el-radio>
            <el-radio label="0" style="margin-bottom: 20px;">录入的是成绩评级或不是成绩,如名次、评语等</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCourseSave">保 存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.examID = this.$route.params.id
      // console.log('传递过来的参数是:' + this.examID)
      this.username = this.$session.get('USERNAME') // 获取session
      this.loadData('', '')
    },
    mounted() {
      this.username = this.$session.get('USERNAME') // 获取session
      console.log('student_ist:' + this.username)
      // this.setCurrent(this.new_position)
    },
    watch: {
      // filterData(val, oldVal) { // 普通的watch监听
      //   if (this.show_selection === true) {
      //     this.setCurrent(this.filterData[this.new_position])
      //   }
      // }
    },
    // 搜索数据
    computed: {
      filterData: function() {
        let that = this
        var input = this.condition && this.condition.toLowerCase()
        var items = this.tableData
        var items1
        if (input) {
          items1 = items.filter(function(item) {
            return Object.keys(item).some(function(key1) {
              return String(item[key1])
                .toLowerCase()
                .match(input)
            })
          })
        } else {
          items1 = items
        }
        that.currentItems = items1

        return items1
      }
    },
    data() {
      return {
        username: '',
        condition: '',
        examID: '',
        tableData: [],
        currentItems: [],
        dialogVisible: false,
        editDialogVisible: false,
        msg: '',
        selectedID: '',
        position: -1,
        form: {
          course_name: '',
          id: '',
          course_type: ''
        },
        formLabelWidth: '80px',
        systemCourses: [],
        new_position: 0,
        show_selection: false
      }
    },
    methods: {

      loadData(sortFieldName, sortType) {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_load_competitions.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {

            // console.log('ddddddddddddddd',response.data)

            that.tableData = response.data.competitions
            that.currentItems = that.tableData

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      editCompetition() {
        this.$router.push({
          name: 'competition_edit',
          params: {
            action_type: 'add_competition',
          }
        })
      },
      delCompetition(index, rows) {
        let cid = rows[index].id
        let that = this

        this.$confirm('确定要删除吗?', '操作提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          var requestUrl = '/score/web/_competition_delete.jsp'
          this.axios.get(requestUrl, {
            params: {
              competition_id: cid
            }
          }).then(function(response) {
            console.log(response)

            that.$message.success('删除成功！！')


            load.close()

            that.loadData('', '')

          }).catch(function(error) {
            console.log(error)
            load.close()
          })
        }).catch(() => {

        })

      },
      manageCompetition(index, rows) {

        let cid = rows[index].id
        let that = this


        this.$router.push({
          name: 'competition_manager',
          params: {
            competition_id: cid
          }
        })
      },
      getImageUrl(image_name) {
        return '/score' + image_name
      },

      indexMethod(index) {
        return index + 1
      },
      indexSysMethod(index) {
        return index + 1
      },
      setCurrent(row) {
        this.$refs.multipleTable.setCurrentRow(row)
      },
      upgrade(index, rows) {
        let courseName = rows[index].course_name
        let that = this

        this.show_selection = true

        this.new_position = index
        if (index > 0) {
          this.new_position = index - 1
        }

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_move_course_position.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              course: courseName,
              direction: 'UPGRADE'
            }
          }).then(function(response) {
            that.tableData = response.data
            that.currentItems = that.tableData
            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      downgrade(index, rows) {
        let courseName = rows[index].course_name
        let that = this

        this.show_selection = true

        this.new_position = index
        if (index < this.currentItems.length - 1) {
          this.new_position = index + 1
        }

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_move_course_position.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              course: courseName,
              direction: 'DOWNGRADE'
            }
          }).then(function(response) {
            that.tableData = response.data
            that.currentItems = that.tableData
            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      deleteSelectedCourses() {
        let that = this
        let courses = this.$refs.multipleTable.selection
        let coursesJsonStr = JSON.stringify(courses)

        this.msg = '要删除选中的科目名称吗？'

        this.$confirm(this.msg, '重要提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            courses: coursesJsonStr,
            username: that.username
          }

          that.show_selection = false

          var qs = require('qs')

          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          var requestUrl = '/score/web/_delete_muti_courses.jsp'

          this.axios.post(
              requestUrl,
              qs.stringify(data), {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }
            ).then(function(response) {
              that.loadData('', '')
              load.close()
            })
            .catch(function(error) {
              console.log(error)
              load.close()
            })
        })
      }
    }
  }
</script>

<style>
  .searchStyle {
    display: flex;
    width: 200px;
    align-items: center;

  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/components/competition_list.vue